window.enhance.loadJS.ready(['libraries', 'jQuery'], {
    success: function () {
        // 
        //var sliderNav = $('.slider--advanced').not('.slick-initialized');
        //if (sliderNav.children().length > 3) {
        //    sliderNav.slick({
        //        variableWidth: true,
        //        dots: true,
        //        infinite: false,
        //        slidesToShow: 4,
        //        slidesToScroll: 1,
        //        responsive: [
        //            {
        //                breakpoint: 769,
        //                settings: {
        //                    dots: false,
        //                    slidesToShow: 1

        //                }

        //            },
        //            {
        //                breakpoint: 1200,
        //                settings: {
        //                    slidesToShow: 2

        //                }


        //            }

        //        ]
        //    });
        //}

        var sliderNavSimple = $('.list-slider--simple').not('.slick-initialized');

        if (sliderNavSimple.children().length > 3) {
            if (window.siteSettings.locale == 'da') {
                sliderNavSimple.on('init',
                    function(event, slick) {
                        sliderNavSimple.find(".slick-next").html("Næste");
                        sliderNavSimple.find(".slick-next").attr("aria-label", "Næste");
                        sliderNavSimple.find(".slick-prev").html("Forrige");
                        sliderNavSimple.find(".slick-prev").attr("aria-label", "Forrige");
                    });
            }

            sliderNavSimple.slick({
                variableWidth: false,
                dots: true,
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            dots: false,
                            slidesToShow: 1
                        }
                    }
                ]
            });

           
        }
    }
});
